export default "__VITE_ASSET__CMwNorCz__"